<template>
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card">
                <h5>{{ $t('menu.editDisplayMarket') }}</h5>
                <Accordion :activeIndex="0">
                    <AccordionTab :header="$t('markets.titles.marketDetails')">
                        <div class="p-grid">
                            <div class="p-col-12 p-md-6">
                                <div class="p-field p-grid" v-show="this.isEdit()">
                                    <label class="p-col-12 p-mb-2 p-md-3 p-mb-md-0">{{ $t('sportsSettings.id') }}</label>
                                    <div class="p-col-12 p-md-8">
                                        <InputText style="width: 100%" type="text" v-model="market.marketId" disabled />
                                    </div>
                                </div>
                                <div class="p-field p-grid">
                                    <label class="p-col-12 p-mb-2 p-md-3 p-mb-md-0">{{ $t('sportsSettings.displayName') }}</label>
                                    <div class="p-col-12 p-md-8">
                                        <InputText style="width: 100%" type="text" v-model="market.displayName" />
                                    </div>
                                </div>
                                <div class="p-field p-grid">
                                    <label class="p-col-12 p-mb-2 p-md-3 p-mb-md-0">{{ $t('sportsSettings.sortOrder') }}</label>
                                    <div class="p-col-12 p-md-8">
                                        <InputText style="width: 100%" type="text" v-model="market.sortNo" />
                                    </div>
                                </div>
                                <div class="p-field p-grid">
                                    <label class="p-col-12 p-mb-2 p-md-3 p-mb-md-0">{{ $t('sportsSettings.displayColumns') }}</label>
                                    <div class="p-col-12 p-md-8">
                                        <InputText style="width: 100%" type="text" v-model="market.displayCols" />
                                    </div>
                                </div>
                            </div>
                            <div class="p-col-12 p-md-6"></div>
                        </div>
                    </AccordionTab>
                    <AccordionTab :header="$t('markets.titles.marketOutcomes')">
                        <div class="p-col-12" v-show="market.outcomes != null">
                            <div class="card p-grid">
                                <div v-for="(outcome, index) in market.outcomes" :key="market.id + '_' + index + '_' + outcome.id" class="p-col-12 p-grid">
                                    <div class="p-field p-grid p-col-12 p-md-2">
                                        <label for="outcomeId" class="p-col-12 p-mb-2 p-md-3 p-mb-md-0">{{ $t('sportsSettings.marketId') }}</label>
                                        <div class="p-col-12 p-md-8">
                                            <InputText style="width: 100%" type="text" v-model="outcome.marketId" disabled />
                                        </div>
                                    </div>
                                    <div class="p-field p-grid p-col-12 p-md-3">
                                        <label class="p-col-12 p-mb-2 p-md-3 p-mb-md-0">{{ $t('sportsSettings.specifier') }}</label>
                                        <div class="p-col-12 p-md-8">
                                            <InputText style="width: 100%" type="text" v-model="outcome.specifier" disabled />
                                        </div>
                                    </div>

                                    <div class="p-field p-grid p-col-12 p-md-2">
                                        <label class="p-col-12 p-mb-2 p-md-3 p-mb-md-0">{{ $t('sportsSettings.outcomeId') }}</label>
                                        <div class="p-col-12 p-md-8">
                                            <InputText style="width: 100%" type="text" v-model="outcome.outcomeId" disabled />
                                        </div>
                                    </div>
                                    <div class="p-field p-grid p-col-12 p-md-3">
                                        <label class="p-col-12 p-mb-2 p-md-3 p-mb-md-0">{{ $t('sportsSettings.displayName') }}</label>
                                        <div class="p-col-12 p-md-8">
                                            <InputText style="width: 100%" type="text" v-model="outcome.displayName" />
                                        </div>
                                    </div>
                                    <div class="p-field p-grid p-col-12 p-md-2">
                                        <label class="p-col-12 p-mb-2 p-md-3 p-mb-md-0">{{ $t('sportsSettings.sortOrder') }}</label>
                                        <div class="p-col-12 p-md-8">
                                            <InputText style="width: 100%" type="text" v-model="outcome.sortNo" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </AccordionTab>
                </Accordion>
                <transition-group name="p-message" tag="div">
                    <Message :key="errorKeyCount" :severity="'error'" v-show="showError">{{ errorText }}</Message>
                </transition-group>
                <div class="p-col-12">
                    <Button @click="submitForm()" :label="$t('buttons.save')" class="p-button-raised p-button-success p-mr-2 p-mb-2" />
                    <Button :label="$t('buttons.cancel')" class="p-button-raised p-button-danger p-mr-2 p-mb-2" @click="goto(backRoute)" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { SportsSettingsApi } from '../../service/SportSettingsApi';
export default {
    data() {
        return {
            SportsSettingsApi: new SportsSettingsApi(),
            market: {},
            showError: false,
            errorText: '',
            disableSubmit: false,
            backRoute: 'displayMarkets',
            errorKeyCount: 0,
            selectedGroups: [],
            showInfo: true,
            groups: [],
        };
    },
    mounted() {
        this.SportsSettingsApi.getAllGroups()
            .then((responseGroups) => {
                this.groups = responseGroups.data;
                this.SportsSettingsApi.getDisplayMarket(this.$route.params.id).then((response) => {
                    this.market = response.data;
                    for (var i = 0; i < this.groups.length; i++) {
                        if (this.market.groups.indexOf(this.groups[i].name) >= 0) {
                            this.selectedGroups.push(this.groups[i].name);
                        }
                    }
                });
            })
            .catch((error) => {
                this.errorText = error;
                this.showError = true;
                this.errorKeyCount++;
            });
    },
    methods: {
        submitForm() {
            this.disableSubmit = true;
            this.errorText = '';
            this.SportsSettingsApi.updateDisplayMarket(this.market)
                .then(() => {
                    this.goto(this.backRoute);
                })
                .catch((error) => {
                    this.disableSubmit = false;
                    this.errorText = error;
                    this.showError = true;
                });
        },
        isEdit() {
            return this.$route.params.id !== '0';
        },
        getOutcomeClass(displayCols) {
            return 'p-mb-2 p-col-12 p-md-' + 12 / displayCols;
        },
    },
};
</script>
